import { Control, FieldValues, UseFormSetValue } from "react-hook-form";

import { TTimeHHmm } from "@ryde/shared";

export interface IRouteScheduleItem {
  time: TTimeHHmm;
  direction: string;
  dayTypeIds: number[];
  dayGroupIds: number[];
}

export interface IRouteScheduleForm {
  fieldName: string;
  control?: Control;
  index?: number;
  onEdit?: () => void;
  onCancel?: () => void;
  onEditStart?: () => void;
  onEditEnd?: () => void;
  value?: Partial<IRouteScheduleItem>;
  setValue?: UseFormSetValue<FieldValues>;
  removeHandler?: (index: number) => void;
  disabledEdit?: boolean;
  disabledRemove?: boolean;
}

export const emptyRouteSchedule = {
  time: "" as TTimeHHmm,
  direction: "",
  dayTypeIds: [],
  dayGroupIds: [],
} as IRouteScheduleItem;
